import React from 'react';
import { Box, Tooltip, IconButton, alpha } from '@mui/material';
import { PlayArrow as PlayIcon, Pause as PauseIcon } from '@mui/icons-material';
import intance from '../../../../commons/utils/axios';

export const AudioPlayer = ({ fileName }: { fileName: string }) => {
    const [playing, setPlaying] = React.useState(false);
    const [audioUrl, setAudioUrl] = React.useState<string | null>(null);
    const audioRef = React.useRef<HTMLAudioElement | null>(null);

    const fetchAudio = async () => {
        try {
            if (fileName.startsWith('data:') || fileName.startsWith('http')) {
                setAudioUrl(fileName);
                return fileName;
            }

            const response = await intance.get(`/v1/ratings/qualifications/audio/${fileName}`, {
                responseType: 'blob'
            });

            // @ts-ignore
            const blob = response instanceof Blob ? response : response.data;
            const url = URL.createObjectURL(blob);
            setAudioUrl(url);
            return url;
        } catch (error) {
            console.error("Error fetching audio:", error);
            return null;
        }
    };

    const togglePlay = async () => {
        let currentUrl = audioUrl;
        if (!currentUrl) {
            currentUrl = await fetchAudio();
        }

        if (currentUrl) {
            // We need a small timeout to ensure the audio element is rendered and has the src
            setTimeout(() => {
                if (audioRef.current) {
                    if (playing) {
                        audioRef.current.pause();
                    } else {
                        audioRef.current.play().catch(err => {
                            console.error("Playback error:", err);
                        });
                    }
                    setPlaying(!playing);
                }
            }, 100);
        }
    };

    React.useEffect(() => {
        return () => {
            if (audioUrl && !audioUrl.startsWith('data:') && !audioUrl.startsWith('http')) {
                URL.revokeObjectURL(audioUrl);
            }
        };
    }, [audioUrl]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <audio
                ref={audioRef}
                src={audioUrl || ''}
                onEnded={() => setPlaying(false)}
                onPause={() => setPlaying(false)}
                onPlay={() => setPlaying(true)}
            />
            <Tooltip title={playing ? "Pausar" : "Reproducir audio"}>
                <IconButton
                    size="small"
                    sx={{
                        bgcolor: playing ? alpha('#5DCC0A', 0.1) : alpha('#3f51b5', 0.1),
                        color: playing ? '#5DCC0A' : '#3f51b5',
                        '&:hover': {
                            bgcolor: playing ? alpha('#5DCC0A', 0.2) : alpha('#3f51b5', 0.2),
                        },
                        transition: 'all 0.3s ease'
                    }}
                    onClick={togglePlay}
                >
                    {playing ? <PauseIcon /> : <PlayIcon />}
                </IconButton>
            </Tooltip>
        </Box>
    );
};
